import type { ComponentProps } from "react";
import type { Table } from "@narmi/design_system";

export const COL_LAYOUT = {
  s: "52px 1fr 1fr 1fr 1fr 227px",
  m: "52px 1fr 1fr 1fr 1fr 227px",
  l: "52px 1fr 1fr 1fr 1fr 227px",
};

export const COL_VISIBILITY: ComponentProps<typeof Table>["colVisibility"] = [
  "*", // checkbox
  "*", // name
  "*", // account
  "*", // routing
  "*", // type
  "*", // action
];

export const CATEGORY_KEYS = [
  "name",
  "account_number",
  "routing_number",
  "account_type",
];
